const NpmIcon = () => (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 9.779v10.667h8.888v1.776h7.112v-1.776h16v-10.667zM8.888 18.664h-1.776v-5.333h-1.78v5.333h-3.552v-7.108h7.108zM14.221 18.664v1.781h-3.553v-8.889h7.112v7.109h-3.559zM30.223 18.664h-1.773v-5.333h-1.781v5.333h-1.78v-5.333h-1.773v5.333h-3.561v-7.108h10.669zM14.22 13.333h1.78v3.556h-1.78z" />
    </svg>
);

export default NpmIcon;
